export const homeRootAnimation = 'Home';
export const resultsPage = 'resultsPage';
export const detailPage = 'detailPage';
export const productHomeRoute = 'home';
export const productResultsRoute = 'results';
export const productResultsOutletRoute = 'results-outlet';
export const productFiltersRoute = 'filters';
export const productResultsDetailRoute = 'detail';
export const productResultsDetailOutletRoute = 'detail-outlet';

export const defaultRouteAngular = 'localhost:4200';
